"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDetectOutsideClick = void 0;
var react_1 = require("react");
var useDetectOutsideClick = function (el, initialState) {
    var _a = react_1.useState(initialState), isActive = _a[0], setIsActive = _a[1];
    react_1.useEffect(function () {
        //return;
        var pageClickEvent = function (ev) {
            // If the active element exists and is clicked outside of
            // @ts-ignore
            if (el.current !== null && !el.current.contains(ev.target)) {
                setIsActive(!isActive);
            }
        };
        // If the item is active (ie open) then listen for clicks
        if (isActive) {
            window.addEventListener('click', pageClickEvent);
        }
        return function () {
            window.removeEventListener('click', pageClickEvent);
        };
    }, [isActive, el]);
    return [isActive, setIsActive];
};
exports.useDetectOutsideClick = useDetectOutsideClick;
